<template>
  <div>
    <prezydencki-template :schema="schema" />

    <w-input class="mb-2" :model="schema.date" />

    <w-input v-if="schema.presidentTitle" class="mb-2" :model="schema.presidentTitle" />

    <w-input v-if="schema.presidentName" class="mb-2" :model="schema.presidentName" />

    <w-wysiwyg v-if="schema.quote" class="mb-2" :model="schema.quote" />

    <w-wysiwyg v-if="schema.indent" class="mb-2" :model="schema.indent" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import PrezydenckiTemplate from './components/PrezydenckiTemplate';

// @vuese
// Formularz dyplomu
// @group ActionData
export default {
  components: { ...components, PrezydenckiTemplate },
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
